<template>
  <!-- Home: dashboard tile grid -->
  <svg v-if="name === 'home'" class="nav-icon" viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="12" height="13" rx="1" fill="currentColor"/>
    <rect x="16" y="1" width="7" height="13" rx="1" fill="currentColor"/>
    <rect x="1" y="17" width="7" height="6" rx="1" fill="currentColor"/>
    <rect x="11" y="17" width="12" height="6" rx="1" fill="currentColor"/>
  </svg>

  <!-- Events: party popper -->
  <svg v-else-if="name === 'events'" class="nav-icon" viewBox="0 0 15.7641 23.4266" width="16" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.84964 21.4302C8.49396 22.2106 7.38545 22.2106 7.02977 21.4302L1.81581 9.99116C1.51398 9.32896 1.998 8.5764 2.72574 8.5764L13.1537 8.5764C13.8814 8.5764 14.3654 9.32896 14.0636 9.99115L8.84964 21.4302Z" stroke="currentColor" stroke-linejoin="round"/>
    <path d="M3.25015 11.9633H12.6292" stroke="currentColor" stroke-linecap="round"/>
    <path d="M7.93971 6.23164V0.5" stroke="currentColor" stroke-linecap="round"/>
    <path d="M15.2214 4.47653C15.4527 3.3 14.7246 2.16624 13.5951 1.94421C12.4656 1.72218 11.3625 2.49596 11.1313 3.67249L10.545 6.65492" stroke="currentColor" stroke-linecap="round"/>
    <path d="M0.542618 4.47649C0.311336 3.29996 1.03946 2.1662 2.16894 1.94417C3.29841 1.72214 4.40152 2.49592 4.6328 3.67245L5.21909 6.65488" stroke="currentColor" stroke-linecap="round"/>
  </svg>

  <!-- Accommodations: lodge building with a door -->
  <svg v-else-if="name === 'accommodations'" class="nav-icon" viewBox="0 0 18 16" width="18" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 15V6.8L16.5 3.4V15H1.5Z" stroke="currentColor" stroke-linejoin="round"/>
    <path d="M8 15V10.5H11.5V15" stroke="currentColor"/>
  </svg>
</template>

<script setup>
defineProps({
  name: {
    type: String,
    required: true,
    validator: (value) => ['home', 'events', 'accommodations'].includes(value)
  }
});
</script>

<style scoped>
.nav-icon {
  flex-shrink: 0;
}
</style>
